module.exports = __webpack_public_path__ + "static/media/as_confirm.7546fef5.png";